<div class="row">
  <div class="col-12">
    <sb-card>
      <div card-header>
        <h3>
          <ng-container *ngIf="company?.name">
            {{ 'lang.globals.levelSettingsForCompany' | translate: {company: company?.name} }}
          </ng-container>
          <ng-container *ngIf="!company?.name">
            {{ 'lang.globals.levelSettings' | translate }}
          </ng-container>
        </h3>
        <small>{{levels?.length}} Level{{levels?.length > 1 ? 's' : ''}}</small>
      </div>
      <div card-header-more>
        <ng-container *ngPermissions="permissionService.Permission.campaign_level_create">
          <button (click)="showEditLevel(null)" class="btn btn-success">
            <sb-icon icon="plus"></sb-icon>
            {{'lang.companyLevel.createLevel' | translate}}</button>
        </ng-container>
      </div>
      <div card-fit>
        <table class="table">
          <thead>
          <tr>
            <th>{{'lang.globals.level' | translate}}</th>
            <th>{{'lang.companyLevel.title' | translate}}</th>
            <th>{{'lang.companyLevel.description' | translate}}</th>
            <th class="text-end">{{'lang.globals.actions' | translate}}</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let level of levels">
            <td>
              {{level?.id?.level}}
            </td>
            <td>
              {{level?.name}}
            </td>
            <td>
              {{level?.description}}
            </td>
            <td class="text-right">
              <button *ngPermissions="permissionService.Permission.campaign_level_edit" (click)="showEditLevel(level)"
                      class="btn btn-hover-primary">
                <sb-icon icon="edit"></sb-icon>
              </button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </sb-card>

  </div>
</div>
